export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_01.625ba395.jpg";